import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MAIN_URL } from '@pf/shared-ui';
import { PlatformAuthService } from '@pf/shared-common';

@UntilDestroy()
@Component({
    template: '',
    standalone: false,
})
export class LoginCallbackComponent implements OnInit {
    private readonly _authService = inject(PlatformAuthService);
    private readonly _router = inject(Router);
    private readonly _mainUrl = inject(MAIN_URL);

    onAuthLoaded() {
        this._router.navigate(['/']);
    }

    onAuthFailed() {
        this._router.navigate(['/login-failed']);
    }

    ngOnInit(): void {
        this._authService
            .getAccessToken()
            .pipe(untilDestroyed(this))
            .subscribe(token => {
                if (token) {
                    this.onAuthLoaded();
                } else {
                    this.onAuthFailed();
                }
            });

        this._authService.error$.pipe(untilDestroyed(this)).subscribe(() => {
            this.onAuthFailed();
        });
    }
}
